import React, { useLayoutEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import { WrapperContainer, imgbaseUrl } from "./SliderItem";
import { ParagraphWithLightBorder, TitleH4 } from "./About";
import { TitleWithBigMargin } from "./Services";
import { DefaultMediaIconContainer, MediaIcon, hrefBaseUrl } from "./Header";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { lgDown, mdDown, smDown, xlDown } from "../utils/responsive";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Container = styled(WrapperContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 48px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -12px;
`;

const CardWrapper = styled.div`
  flex-basis: 33.33%;
  ${mdDown({
    flexBasis: "50%",
  })}
  ${smDown({
    flexBasis: "100%",
  })}
  padding: 0 12px;
  padding-top: 24px;
  &:first-of-type {
    ${smDown({
      paddingTop: 0,
    })}
  }
`;

const Card = styled.div`
  padding: 16px 0;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    & > div {
      background-color: ${({ theme }) => theme.palette.primary.main};
    }
    & h4 {
      color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

const CardImg = styled.img`
  border-radius: ${({ theme }) => theme.borderRadius};
  width: 100%;
  height: 300px;
  object-fit: cover;
  display: block;
  margin-bottom: 24px;

  ${smDown({
    height: "auto",
    maxWidth: "280px",
  })}

  ${mdDown({
    height: "250px",
  })}
`;

const ProfileDetails = styled.div`
  text-align: center;
  width: 100%;
  max-width: 300px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};
  border-radius: ${({ theme }) => theme.borderRadius};
  transition: background-color 300ms linear;
`;

const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const StyledMediaIconContainer = styled(DefaultMediaIconContainer)`
  background-color: ${({ theme }) => theme.palette.primary.light};
  transition: background-color 300ms linear;
  width: 38px;
  height: 38px;
  margin: 0 4px;
  cursor: pointer;

  & svg {
    transition: color 300ms linear;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
    & svg {
      color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`;

const Team = () => {
  interface CardItemType {
    name: string;
    img: number;
    role: string;
  }

  const cardItem: CardItemType[] = useMemo(
    () => [
      {
        name: "Mr. Kwame Atta Acheampong",
        role: "Board Chairman",
        img: 5,
      },
      {
        name: "Mr. William Kuffour Bonsu",
        role: "Managing Director",
        img: 2,
      },
      {
        name: "Mr. Benjamin Kweku Acolatse",
        role: "Director",
        img: 1,
      },
     
      {
        name: "Mr. Kelvin Williams Aye-Kumi",
        role: "Head, Credit Risk",
        img: 3,
      },
      {
        name: "Eunice Adane Yeboah",
        role: "Head, Finance",
        img: 6,
      },
      {
        name: "Joseph Eshun Nunoo",
        role: "Compliance and Audit",
        img: 4,
      },
    
    
    ],
    []
  );

  const containerEl = useRef<HTMLDivElement>(null);
  const topEl = useRef<HTMLDivElement>(null);
  const cardWrapperEls = useRef<HTMLDivElement[]>([]);
  const addToCardwrapperRefs = (el: HTMLDivElement) => {
    if (el && !cardWrapperEls.current.includes(el))
      cardWrapperEls.current.push(el);
  };

  useLayoutEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerEl.current,
        start: "top center",
      },
    });
    tl.from(topEl.current, {
      opacity: 0,
      y: "100%",
    }).from(cardWrapperEls.current, {
      opacity: 0,
      y: "100%",
      stagger: 0.2,
    });

    return () => {
      tl.scrollTrigger?.kill();
    };
  }, []);

  const handleLoad = () => {
    ScrollTrigger.refresh();
  };

  return (
    <Container ref={containerEl}>
      <Top ref={topEl}>
        <ParagraphWithLightBorder>Our Team</ParagraphWithLightBorder>
        <TitleWithBigMargin>Exclusive Team</TitleWithBigMargin>
      </Top>
      <CardContainer>
        {cardItem.map(({ name, img }, idx) => (
          <CardWrapper ref={addToCardwrapperRefs} key={idx}>
            <Card>
              <CardImg
                onLoad={handleLoad}
                src={`${imgbaseUrl}team-${img}.jpg`}
              />
              <ProfileDetails>
                <TitleH4 style={{ margin: 0 }}>{name}</TitleH4>
                {/* <MediaContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faFacebookF} />
                  </StyledMediaIconContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faTwitter} />
                  </StyledMediaIconContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faInstagram} />
                  </StyledMediaIconContainer>
                </MediaContainer> */}
              </ProfileDetails>
            </Card>
          </CardWrapper>
        ))}
      </CardContainer>
    </Container>
  );
};

export default Team;
